import React from 'react';
import {
  Formik,
  Field,
} from 'formik';

import {
  Flex,
  Text,
} from 'web-styled';
import {
  Modal,
  Button,
  CheckboxField,
} from 'web-components';

type Group = {
  id: number,
  name: string,
};

type Props = {
  isOpen: boolean;
  groups: Array<Group>;
  onChecked: { (): void};
  onSubmit: { (values: any, actions: any): void };
  onRequestClose: { (): void };
};

const MoveToGroup = ({
  isOpen,
  groups,
  onSubmit,
  onRequestClose,
  onChecked,
}: Props) => (
  <Modal
    title="Move to Group(s)"
    isOpen={isOpen}
    onRequestClose={onRequestClose}
  >
    <Formik
      initialValues={{}}
      onSubmit={onSubmit}
    >
      {(formikProps) => (
        <Flex
          column
          as="form"
          width="100%"
          spacing={15}
          onSubmit={formikProps.handleSubmit}
        >
          <Text>Select groups to move selected client(s) to</Text>
          {groups.map(group => (
            <Field
              key={group.id}
              name={group.name}
              value={group.id}
              label={group.name}
              component={CheckboxField}
              onChange={() => onChecked({
                resource: 'clientGroups',
                selectedIds: groups.filter(gr => gr.selected).map(g => g.id),
                id: group.id,
              })}
            />
          ))}
          <Flex width="100%" justify="flex-end">
            <Button
              ghost
              appearance="primary"
              spacing="large"
              type="submit"
              isLoading={formikProps.isSubmitting}
              isDisabled={formikProps.isSubmitting}
            >
              Move to group(s)
            </Button>
          </Flex>
        </Flex>
      )}
    </Formik>
  </Modal>
);

export default MoveToGroup;
